import { c as _c } from "react/compiler-runtime";
// Third Party
import * as React from 'react';
import { useToggle } from '@hooks';
export function useModal() {
  const $ = _c(7);
  const {
    on: modalActive,
    setOff: closeModal,
    setOn: openModal
  } = useToggle();
  let t0;
  let t1;
  if ($[0] !== modalActive) {
    t0 = () => {
      if (modalActive) {
        document.body.classList.add("modalActive");
      } else {
        document.body.classList.remove("modalActive");
      }
    };
    t1 = [modalActive];
    $[0] = modalActive;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  React.useEffect(t0, t1);
  let t2;
  if ($[3] !== closeModal || $[4] !== modalActive || $[5] !== openModal) {
    t2 = {
      modalActive,
      closeModal,
      openModal
    };
    $[3] = closeModal;
    $[4] = modalActive;
    $[5] = openModal;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}